const sensitiveKeys = [ 'accesstoken', 'password' ];

/**
 * Replaces the value of any sensitive key, at any depth, before extras reach the console or Sentry.
 * Arrays are rebuilt as arrays: spreading one into an object turns it into `{0: ..., 1: ...}` and
 * drops its length, which is how a list of diagnostics would arrive unreadable. Other non-plain
 * objects, `Error` and `Date` among them, still flatten to `{}`: a spread copies only own
 * enumerable properties, which neither has.
 */
export const scrubSensitiveKeys = (data: any): any => {
    if (!data || typeof data !== 'object') {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map(item => scrubSensitiveKeys(item));
    }
    const result = { ...data };
    for (const key of Object.keys(result)) {
        if (sensitiveKeys.includes(key.toLowerCase())) {
            result[key] = '***';
        } else {
            result[key] = scrubSensitiveKeys(data[key]);
        }
    }
    return result;
};
